/** Blacklist page strings (extracted to keep en.ts under the size ratchet). */

import { enBlacklistOverride } from "./enBlacklistOverride";

export const enBlacklist = {
	override: enBlacklistOverride,
	/** The "also blacklist the company" toggle names the company it blocks (PREC-4425). */
	companyToggle: {
		one: "Also blacklist {{name}} ({{identifier}})",
		oneByName: "Also blacklist {{name}}",
		oneUnnamed: "Also blacklist this lead's company",
		several: "Also blacklist the {{count}} companies of these leads",
		unknown: "Also blacklist the companies of the selected leads",
		hint: "The company the lead works at now. Blocks every lead at it, on every list.",
		hintSeveral: "The companies the leads work at now. Blocks every lead at them, on every list.",
		none_one: "No company is known for this lead, so only the person can be blacklisted.",
		none_other: "No company is known for these leads, so only the people can be blacklisted.",
	},
	title: "Blacklist",
	addFailed: "The leads could not be blacklisted.",
	confirmSelected:
		"Are you sure you want to add {{count}} selected items to the Blacklist? This action is permanent and cannot be undone. Please specify if you want to add only people to the blacklist or their entire companies.",
	search: "Search for blacklist",
	domain: "Domain",
	email: "Email",
	linkedinUrl: "LinkedIn URL",
	type: "Type",
	create: {
		button: "Create New Blacklist",
		title: "Create New Blacklist",
		upload: "Upload Blacklist",
	},
	delete: {
		title: "Delete Blacklist",
		confirmation: "Are you sure you want to delete this blacklist?",
	},
	upload: {
		downloadExample: "Download Example CSV",
		scopeLabel: "What should be imported from the file?",
		scopeBoth: "People and companies",
		scopePerson: "People only",
		scopeOrganization: "Companies only",
		scopeHint:
			'A single row can describe a person and their company. With "People and companies" that becomes two entries — and the company entry blocks every lead at that company, not just the person named.',
		dragAndDrop: "Drag and drop a CSV file here, or click to select one",
		formatHint:
			"The first row must be a header. Supported columns: domain, email, linkedinUrl, linkedinCompanyUrl — include any subset, and each row may describe a person, a company, or both. Comma- and semicolon-separated files both work.",
		fileRequired: "Please select a CSV file to upload.",
		typeError: "Only .csv files are supported.",
		sizeError: "The selected file is too large.",
		forbidden: "You do not have permission to import blacklist entries.",
		uploadFailed: "The upload failed. Please try again.",
		nothingImported: "No entries were imported from this file.",
		importedToast: "Imported {{count}} blacklist entries.",
		summary:
			"Imported {{imported}} entries from {{total}} rows ({{persons}} people, {{organizations}} companies) — {{duplicates}} already blacklisted, {{skipped}} skipped.",
		ignoredColumns: "Ignored columns: {{columns}}",
		rowError: "Row {{row}}: {{reason}}",
	},
};
